import Vue from 'vue'
import axios from 'axios'
import _ from 'lodash'
// import store from '@/store'
import qs from 'querystringify'
import getSignature from './signature'

// create an axios instance
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})
// const client_id = process.env.VUE_APP_CLIENT_ID
// const serv = store.state.serv[client_id]
console.log(process.env)
const API_HOST = process.env.VUE_APP_API_HOST
const APP_HOST = process.env.VUE_APP_APP_HOST
const CAPP_HOST = process.env.VUE_APP_CAPP_HOST
const WWW_HOST = process.env.VUE_APP_WWW_HOST
// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    const { method, data, contentType, url } = config
    // 判断接口是不是调取api
    if (url.startsWith('/v4/openapi') || url.startsWith('/v4/') || url.startsWith('/v4/client/apps/cityservice') || url.startsWith('/v4/ads') || url.startsWith('/v4/news/hot-dynamic-screens') || url.startsWith('/v5/')) {
      config.baseURL = API_HOST
    } else if (url.startsWith('/api/v1') || url.startsWith('/wechat/js_api')) {
      if (url.startsWith('/api/v1/zhengzai') || url.startsWith('/api/v1/renda') || url.startsWith('/api/v1/wechat') || url.startsWith('/api/v1/reporter') || url.startsWith('/api/v1/suchao')) {
        // 否则调取capp
        config.baseURL = CAPP_HOST
      } else {
        // 否则调取app
        config.baseURL = WWW_HOST
      }
    } else {
      // 否则调取app
      config.baseURL = APP_HOST
    }
    // console.log(111)
    if (config.data) {
      if (config.data && !config.data.signature) {
        if (config.data instanceof FormData) {
          config.params = getSignature()
        } else {
          Object.assign(config.data, getSignature())
        }
      }
    } else {
      if (config.params) {
        if (!config.params.signature) {
          Object.assign(config.params, getSignature())
        }
      } else {
        config.params = getSignature()
      }
    }
    if (contentType === 'json') {
      config.headers['Content-Type'] = 'application/json'
    } else if (method !== 'get' && _.isObject(data)) {
      if (typeof config.headers['Content-Type'] === 'undefined') {
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        if (config.data instanceof FormData) {
          config.headers['Content-Type'] = 'multipart/form-data'
        }
        // if (!config.url.startsWith('/api/v4/teletexts/')) {
        //   config.data = qs.stringify(data)
        // }
      } else if (config.headers['Content-Type'] == 'application/x-www-form-urlencoded') {
        config.data = qs.stringify(data)
      }
    }
    if (sessionStorage.getItem('X-Authorization')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('X-Authorization')
    }
    // 小记者核销
    if (sessionStorage.getItem('XIAOJIZHE_HEXIAO_TOKEN')) {
      config.headers['X-Authorization'] = sessionStorage.getItem('XIAOJIZHE_HEXIAO_TOKEN')
    }
    // if (store.getters.token) {
    // config.headers['X-Auth-Token'] = encodeURIComponent(getToken())
    // }
    if (process.env.NODE_ENV == 'development') {
      config.baseURL = ''
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error, 222) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
      //   // to re-login

      // }
      if (parseInt(res.code) === 11201) {
        return Promise.reject(res)
      }
      if (parseInt(res.code) === 20002 || parseInt(res.code) === 402 || parseInt(res.code) === 11101) {
        // token过期
        sessionStorage.removeItem('X-Authorization')
        sessionStorage.removeItem('access_token')
        window.PalauAPI.user.refreshToken((val) => {
          if (val) {
            // 已登录
            sessionStorage.setItem('access_token', val)
            window.location.reload()
          }
        })
        // return Promise.reject(new Error(res.message || 'Error'))
      }
      if (res.message) {
        return Promise.reject(new Error(res.message || res.msg || 'Error'))
      } else {
        return Promise.reject(res.msg || 'Error')
      }
    } else {
      return res
    }
  },
  (error) => {
    console.log('err' + error)
    return Promise.reject(error)
  }
)
Vue.$request = service
export default service
